import { getCurrentTheme, THEME_CSS_VARS, Theme } from "../theme";

function readCssVar(cssVar: string, fallback: string): string {
  if (typeof document !== "undefined") {
    const value = getComputedStyle(document.documentElement).getPropertyValue(cssVar).trim();
    if (value) {
      return value;
    }
  }
  return fallback;
}

function readThemeValue(key: keyof Theme, defaultValue: string): string {
  const cssVar = THEME_CSS_VARS[key];
  const themeValue = getCurrentTheme()[key];
  return readCssVar(cssVar, themeValue || defaultValue);
}

export const getBackgroundColor = () => readThemeValue("backgroundColor", "#F2ECE2");
export const getHeaderColor = () => readThemeValue("headerColor", "#F2ECE2");
export const getHeaderTextColor = () => readThemeValue("headerTextColor", "#000");
export const getBoxBackgroundColor = () => readThemeValue("boxBackgroundColor", "#fff");
export const getButtonColor = () => readThemeValue("buttonColor", "#000");
export const getButtonDisabledColor = () => readThemeValue("buttonDisabledColor", "#555");
export const getButtonTextColor = () => readThemeValue("buttonTextColor", "#fff");
export const getColorAccent1 = () => readThemeValue("colorAccent1", "#4d813c");
export const getTextColor = () => readThemeValue("textColor", "#000");

/** Namespace object with runtime-aware getters (for MenuNavLink etc.). */
export const themeColors = {
  get backgroundColor() {
    return getBackgroundColor();
  },
  get headerColor() {
    return getHeaderColor();
  },
  get headerTextColor() {
    return getHeaderTextColor();
  },
  get boxBackgroundColor() {
    return getBoxBackgroundColor();
  },
  get buttonColor() {
    return getButtonColor();
  },
  get buttonDisabledColor() {
    return getButtonDisabledColor();
  },
  get buttonTextColor() {
    return getButtonTextColor();
  },
  get colorAccent1() {
    return getColorAccent1();
  },
  get textColor() {
    return getTextColor();
  },
};
